import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useGlobal } from 'reactn';
import { useApi } from 'stores/api';
import { fmtPrice, fmtDatetime } from 'stores/utils';
import { BOOKING_STATUS_TYPE } from 'stores/const';

const usePrev = value => {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};

const Bookings = (props) => {

    const { t } = useTranslation(['user-bookings']);
    const api = useApi();

    const [masterData] = useGlobal('masterData');
    const [recentBookings, setRecentBookings] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [canLoadMore, setCanLoadMore] = useState(false);
    const FILTER_TYPES = {
        ARCHIVED: 'ARCHIVED',
        ACTIVE: 'ACTIVE',
    }
    const [displayFilter, setDisplayFilter] = useState(FILTER_TYPES.ACTIVE);
    const [filterChanged, setFilterChanged] = useState(false);

    const fetchRecentBookings = async () => {
        const startDT = new Date();
        const endDT = new Date();
        const isActive = displayFilter === FILTER_TYPES.ACTIVE;
        if (isActive) {
            endDT.setFullYear(endDT.getFullYear() + 10);
        } else {
            startDT.setFullYear(startDT.getFullYear() - 10);
        }
        const pageSize = 30;

        let myBookings = await api.fetchRecentBookings({ startDT, endDT, pageSize, pageNumber, isActive });
        setFilterChanged(false);
        if (myBookings.length > 0) {
            setRecentBookings([...recentBookings, ...myBookings]);
        }
        if (myBookings.length >= pageSize) {
            setCanLoadMore(true);
            setPageNumber(pageNumber + 1);
        } else {
            setCanLoadMore(false);
        }
    }

    useEffect(() => {
        fetchRecentBookings();
    }, []);

    useEffect(() => {
        if (filterChanged) {
            fetchRecentBookings();
        }
    }, [filterChanged]);

    const loadMore = () => {
        fetchRecentBookings();
    }

    const updateDisplayFilter = (newFilter) => {
        setPageNumber(1);
        setRecentBookings([]);
        setDisplayFilter(newFilter);
        setFilterChanged(true);
    }

    return (
        <>
            <section className="my-bookings-filter-container sticky-container">
                <div className="filter-header-wrapper">
                    <div className="wrapper">
                        <div className="row">
                            <div className="column-12 filter-rightAlign">
                                {displayFilter === FILTER_TYPES.ACTIVE &&
                                    <a onClick={() => updateDisplayFilter(FILTER_TYPES.ARCHIVED)}
                                        className="archive">{t("archivedBookings")} <i className="fa fa-archive" aria-hidden="true"></i></a>
                                }
                                {displayFilter === FILTER_TYPES.ARCHIVED &&
                                    <a onClick={() => updateDisplayFilter(FILTER_TYPES.ACTIVE)}
                                        className="archive">{t("activeBookings")} <i className="fa fa-archive" aria-hidden="true"></i></a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="my-bookings-container">
                <div className="wrapper">
                    <div className="row">
                        <div className="column-12">
                            <h1 className="mali-blue">{t("myBookings")}</h1>
                            {!recentBookings.length > 0 &&
                                <span className="no-bookings-message">{t("noBookingsYet")}</span>
                            }
                            {recentBookings.length > 0 &&
                                <div className="table myBookingList-table">
                                    <div className="tableheader">
                                        <div className="tabledata column-1 tablet">
                                            {t("number")}
                                        </div>
                                        <div className="tabledata column-3">
                                            {t("object")}
                                        </div>
                                        <div className="tabledata column-2">
                                            {t("start")}
                                        </div>
                                        <div className="tabledata column-2 tablet">
                                            {t("end")}
                                        </div>
                                        {(!masterData.organization.FreeOfCharge) && <div className="tabledata column-2 right mobile">
                                            {t("price")}
                                        </div>}
                                        <div className="tabledata column-2">
                                            {t("status")}
                                        </div>
                                    </div>

                                    {recentBookings.map(booking =>
                                        <Link to={`/user/bookingdetails/${booking.Id}`} className={"tablerow " + (booking.refRentalTransactionStatusId === BOOKING_STATUS_TYPE.CANCELLED ? "cancelled" : "booked")}>
                                            <div className="tabledata column-1 number tablet">
                                                {booking.Number}
                                            </div>
                                            <div className="tabledata column-3">
                                                {booking.Name}
                                            </div>
                                            <div className="tabledata column-2 number">
                                                {fmtDatetime(new Date(booking.RentingStartDate.substring(0, 19)))}
                                            </div>
                                            <div className="tabledata column-2 number tablet">
                                                {fmtDatetime(new Date(booking.RentingEndDate.substring(0, 19)))}
                                            </div>
                                            {(!masterData.organization.FreeOfCharge) && <div className="tabledata column-2 right number mobile">
                                                {booking.Currency_Name}&nbsp;{fmtPrice(booking.TotalDiscountedPrice)}
                                            </div>}
                                            <div className="tabledata column-2">
                                                <span>{booking.RentalTransactionStatus_Name}</span>
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                    {canLoadMore && <div className="row load-more">
                        <div className="column-12">
                            <button onClick={loadMore}>{t("loadMore")} <i className="fa fa-refresh"></i></button>
                        </div>
                    </div>}
                </div>
            </section>
        </>
    );
}

export default Bookings;